import { useEffect, useState } from 'react';

/** Keeps an unsent message draft per conversation across reloads. */
export function useDraft(key: string): [string, (v: string) => void] {
  const storageKey = `lumnos.draft.${key}`;
  const [value, setValue] = useState(() => { try { return localStorage.getItem(storageKey) ?? ''; } catch { return ''; } });
  useEffect(() => { try { setValue(localStorage.getItem(storageKey) ?? ''); } catch { setValue(''); } }, [storageKey]);
  const set = (v: string) => {
    setValue(v);
    try { if (v) localStorage.setItem(storageKey, v); else localStorage.removeItem(storageKey); } catch { /* ignore */ }
  };
  return [value, set];
}
